import service from '@/store/services/profile-service';

const state = {
  me: null,
};

const mutations = {
  SET_RESOURCE: (state, me) => {
    state.me = me;
  }
};

const actions = {
  me({commit, dispatch}, params) {
    return service.get(params)
      .then((profile) => {
        // profile.list.role = "mantap"
        // console.log(profile.list.role)
        if(profile && profile.list && profile.list.role){
        var data = profile.list.role;
        console.log(data)
        var grouped = _.mapValues(_.groupBy(data, 'name_model'),
                          clist => clist.map(data => _.omit(data, 'name_model')));
        
    var dataPermission=[];
    Object.entries(grouped).forEach(([key, value]) => {
 
      var menuP=0;
      var createP=0;
      var editP=0;
      var updateP=0;
      var deleteP=0;
      var requesterP=0;
      var approverP=0;

      value.some(data => data.permission_type === "menu") ? menuP = 1: menuP = 0;
      value.some(data => data.permission_type === "create") ? createP=1 : createP=0;
      value.some(data => data.permission_type === "edit") ? editP=1 : editP=0;
      value.some(data => data.permission_type === "update") ? updateP=1 : updateP=0;
      value.some(data => data.permission_type === "delete") ? deleteP=1 : deleteP=0;
      value.some(data => data.permission_type === "requester") ? requesterP=1 : requesterP=0;
      value.some(data => data.permission_type === "approver") ? approverP=1 : approverP=0;

     
      //dataPermission.push({model:key, model_id:value[0]['model_id'], menu:menuP, create:createP, edit:editP, update:updateP, delete:deleteP, requester:requesterP, approver:approverP })
      dataPermission[key.replace('App\\Models\\','')] = {model:key, model_id:value[0]['model_id'], menu:menuP, create:createP, edit:editP, update:updateP, delete:deleteP, requester:requesterP, approver:approverP }

    })

    profile.list.role = dataPermission



        commit('SET_RESOURCE', profile.list);
      }
      else{
        commit('SET_RESOURCE', null);
      }
        
      });
  },

  clear_me({commit, dispatch}, params) {
    
        commit('SET_RESOURCE', null);
      
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((profile) => {
        commit('SET_RESOURCE', profile);
      });
  },
};

const getters = {
  me: state => state.me
};

const profile = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default profile;
